/**
 * Represents a hyperlink to the location of an item in a specific Catalog.
 *
 * @class CatalogLink
 */
class CatalogLink {
	/**
	 * Creates an instance of CatalogLink.
	 * @param {any} url The URL of the page the link goes to.
	 * @param {any} target Specifies where to open the linked document.
	 * @memberof CatalogLink
	 */
	constructor(url, target) {
		this.href = url;
		this.target = target;
	}
}

export default CatalogLink;



// WEBPACK FOOTER //
// ./src/lib/CatalogLink.js